import './SocialMedia.css';

export default function SocialMedia() {
  return (
    <div >
      <p></p>
    </div>
  );
};
